export default __webpack_public_path__ + "static/media/Parallax-HUD-04.495e4dea.jpg";